export default __webpack_public_path__ + "static/media/404.a9dd6839.png";